import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BsWhatsapp } from "react-icons/bs";
import Footer from '../../components/Footer/Footer';
import BannerImage from "../../assets/ElementaryBanner.jpeg";
import HeadImage from "../../assets/phinehas.jpeg";
import { MdMenuBook, MdCalculate, MdScience, MdPublic, MdHistory, MdPalette, MdComputer, MdBalance, MdEmojiPeople, MdAutoGraph, MdFormatQuote } from 'react-icons/md';
import { FaUser } from 'react-icons/fa6';
import axios from 'axios';
import { api_url } from '../../url';
import { RotatingLines } from 'react-loader-spinner';

// Activity collage images
import EActImg1  from "../../assets/elementary/elementary1.jpeg";
import EActImg2  from "../../assets/elementary/elementary2.jpeg";
import EActImg3  from "../../assets/elementary/elementary3.jpeg";
import EActImg4  from "../../assets/elementary/elementary4.jpeg";
import EActImg5  from "../../assets/elementary/elementary5.jpeg";
import EActImg6  from "../../assets/elementary/elementary6.jpeg";
import EActImg7  from "../../assets/elementary/elementary7.jpeg";
import EActImg8  from "../../assets/elementary/elementary8.jpeg";
import EActImg9  from "../../assets/elementary/elementary9.jpeg";
import EActImg10 from "../../assets/elementary/elementary10.jpeg";
import EActImg11 from "../../assets/elementary/elementary11.jpeg";
import EActImg12 from "../../assets/elementary/elementary12.jpeg";
import EActImg13 from "../../assets/elementary/elementary13.jpeg";
import EActImg14 from "../../assets/elementary/elementary14.jpeg";


const ElementarySchool = () => {
    const location = useLocation();

    const [elementaryEvents, setElementaryEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(false);

    const getElementaryEvents = async () => {
        setLoadingEvents(true);
        try {
            const response = await axios.get(`${api_url}website/upcoming-events/?school=Elementary School`);
            setElementaryEvents(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadingEvents(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getElementaryEvents();
    }, [location]);

    const lowerCurriculum = [
        { icon: <MdMenuBook />, title: "English Language", desc: "Reading, writing, grammar, and oral communication." },
        { icon: <MdCalculate />, title: "Mathematics", desc: "Numeracy, problem-solving, and logical reasoning." },
        { icon: <MdScience />, title: "Science", desc: "Observation, experimentation, and environmental awareness." },
        { icon: <MdPublic />, title: "Geography", desc: "Exploring the world and its features." },
        { icon: <MdHistory />, title: "History", desc: "Foreign and local historical contexts." },
        { icon: <MdPalette />, title: "Creative Arts", desc: "Developing artistic expression and creativity." },
        { icon: <MdComputer />, title: "ICT", desc: "Foundational digital literacy." },
        { icon: <MdBalance />, title: "Moral & Civic", desc: "Developing values and civic responsibility." }
    ];

    const upperCurriculum = [
        { icon: <MdMenuBook />, title: "Advanced English", desc: "Literature and sophisticated writing skills." },
        { icon: <MdCalculate />, title: "Higher Mathematics", desc: "Complex problem-solving and logic." },
        { icon: <MdScience />, title: "Integrated Science", desc: "Analytical scientific studies." },
        { icon: <MdPublic />, title: "Social Studies", desc: "Understanding society and civic duty." },
        { icon: <MdComputer />, title: "ICT & Digital Literacy", desc: "Advanced digital skills and research." },
        { icon: <MdPalette />, title: "Performing Arts", desc: "Creative and performing arts focus." }
    ];

    return (
        <div className="font-sans text-gray-900 overflow-x-hidden">
            

            {/* Hero Section - Different style from Preschool */}
            <div className="relative h-[70vh] w-full flex items-center justify-center overflow-hidden bg-[#021d53]">
                <img 
                    src={BannerImage} 
                    alt="Elementary School Banner" 
                    className="absolute inset-0 h-full w-full object-cover opacity-70"
                />
                <div className="relative z-10 text-center px-5 max-w-4xl">
                    <h1 className="text-4xl md:text-7xl font-black text-white mb-6 tracking-tight [text-shadow:_0_4px_12px_rgb(0_0_0_/_80%)]">Elementary School</h1>
                    <p className="text-blue-50 text-xl font-medium max-w-2xl mx-auto leading-relaxed [text-shadow:_0_2px_8px_rgb(0_0_0_/_80%)]">
                        Building on strong foundations to develop confident, independent learners.
                    </p>
                </div>
            </div>

            {/* Introduction Section */}
            <section className="py-24 px-5 md:px-20 lg:px-40 bg-white relative">
                  <div className="absolute top-0 right-0 w-64 h-64 bg-gray-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 overflow-hidden"></div>
                <div className="max-w-4xl mx-auto text-center space-y-8">
                    <h2 className="text-3xl md:text-5xl font-extrabold text-[#221b2d]">Building on Strong Foundations</h2>
                    <p className="text-xl text-gray-600 leading-relaxed">
                        At Anell School of Excellence, our Elementary School builds on the strong foundation laid in the early years. This phase is designed to deepen understanding, strengthen character, and develop confident, independent learners who are ready for increasing academic responsibility.
                    </p>
                    <p className="text-[#ed3137] font-bold text-lg uppercase tracking-widest">Two Key Stages of Excellence</p>
                </div>
            </section>

            {/* Head of Elementary School Welcome Message */}
            <section className="py-16 px-5 md:px-20 lg:px-40 bg-[#f8f9fa] mb-5">
                <div className="max-w-5xl mx-auto">
                    {/* Section Label */}
                    <div className="flex items-center gap-4 mb-10">
                        <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                        <p className="text-[#ed3137] font-bold uppercase tracking-widest text-sm">Welcome Message from the Head of Elementary School</p>
                        <div className="h-1 flex-1 bg-gray-200 rounded-full"></div>
                    </div>

                    <div className="relative">
                        {/* Floated image – text wraps around it */}
                        <div className="float-right ml-8 mb-6 w-56 md:w-72 shrink-0">
                            <div className="relative">
                                <div className="absolute -top-3 -left-3 w-full h-full border-4 border-[#021d53] rounded-2xl"></div>
                                <img
                                    src={HeadImage}
                                    alt="Mr. Phinehas Agyekum Donkor – Head of Elementary School"
                                    className="relative w-full h-72 md:h-80 object-cover object-top rounded-2xl shadow-xl"
                                />
                                <div className="mt-4 bg-[#021d53] text-white rounded-xl px-4 py-3 text-center">
                                    <p className="font-bold text-sm leading-tight">Mr. Phinehas Agyekum Donkor</p>
                                    <p className="text-[#ed3137] text-xs font-semibold mt-1 uppercase tracking-wide">Head of Elementary School</p>
                                </div>
                            </div>
                        </div>

                        {/* Opening quote icon */}
                        <MdFormatQuote className="text-6xl text-[#021d53]/10 -mb-4" />

                        <h2 className="text-2xl md:text-3xl font-extrabold text-[#021d53] mb-6 leading-snug">
                            Welcome to the Elementary School of<br className="hidden md:block" /> Anell School of Excellence
                        </h2>

                        <div className="space-y-4 text-gray-600 leading-relaxed text-[15px]">
                            <p>
                                It is with great pleasure that I welcome you to a vibrant learning community where every child is nurtured to achieve academic excellence and personal growth. Our Elementary School serves as a strong foundation in the educational journey of our learners, where curiosity is inspired, talents are discovered, and character is shaped.
                            </p>
                            <p>
                                Our academic structure is thoughtfully designed to provide a balanced and progressive learning experience. We follow a well-organized curriculum that integrates core subjects such as Mathematics, English Language, Science, and Social Studies with complementary areas including Computing, Creative Arts, Geography, Global Perspectives, Ghanaian Language, French, History and Religious, Moral &amp; Health Education. This structure ensures that learners develop strong literacy, numeracy, analytical, and problem-solving skills while gaining exposure to diverse fields of knowledge.
                            </p>
                            <p>
                                Beyond academics, we are deeply committed to the holistic development of every learner. We believe education goes beyond the classroom, and as such, we intentionally cultivate the cognitive, social, emotional, and physical growth of our pupils. Through co-curricular activities, collaborative learning, leadership opportunities, and value-based education, we equip our learners with confidence, creativity, discipline, and a strong sense of responsibility.
                            </p>
                            <p>
                                At Anell School of Excellence, we foster a supportive and inclusive environment where every child feels valued and motivated to excel. Our dedicated facilitators employ modern, learner-centered teaching approaches to meet the needs of each child, ensuring that no learner is left behind.
                            </p>
                            <p>
                                We look forward to partnering with you in shaping well-rounded individuals who are prepared not only for academic success but also for life beyond the classroom.
                            </p>
                            <p className="font-semibold text-gray-700">Thank you for choosing Anell School of Excellence.</p>
                        </div>

                        {/* Signature */}
                        <div className="mt-8 pt-6 border-t border-gray-200 clear-both">
                            <p className="font-bold text-[#021d53] text-lg">Mr. Phinehas Agyekum Donkor</p>
                            <p className="text-[#ed3137] font-semibold text-sm uppercase tracking-widest mt-1">Head of Elementary School</p>
                        </div>

                        <div className="clear-both"></div>
                    </div>
                </div>
            </section>

            <div className="grid grid-cols-12 px-5 md:px-20 lg:px-40 gap-10">
                <div className="col-span-12 lg:col-span-8">
                    {/* Key Stages - Split Screen Layout */}
                    <section className="bg-gray-50 overflow-hidden rounded-3xl">
                        <div className="max-w-full flex flex-col xl:flex-row">
                            {/* Lower Elementary */}
                            <div className="xl:w-1/2 p-10 bg-white group hover:bg-[#021d53] transition-all duration-700">
                                <div className="flex items-center gap-4 mb-8">
                                    <span className="text-5xl font-black text-gray-200 group-hover:text-white/20 transition-colors">01</span>
                                    <h3 className="text-3xl font-bold text-[#021d53] group-hover:text-white">Lower Elementary</h3>
                                </div>
                                <p className="text-[#ed3137] font-bold mb-6">Year 1 – Year 3</p>
                                <p className="text-gray-600 group-hover:text-blue-100 text-lg mb-10 leading-relaxed">
                                    Focusing on strengthening core academic skills while nurturing curiosity and confidence. Learners transition from guided foundational learning to more structured academic engagement.
                                </p>
                                
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                    {lowerCurriculum.map((item, idx) => (
                                        <div key={idx} className="flex items-start gap-3">
                                            <div className="text-2xl text-[#ed3137] mt-1 shrink-0">{item.icon}</div>
                                            <div className="text-sm font-semibold text-gray-700 group-hover:text-white">{item.title}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Upper Elementary */}
                            <div className="xl:w-1/2 p-10 bg-[#f8f9fa] group hover:bg-[#ed3137] transition-all duration-700 border-l border-gray-200 xl:border-none">
                                <div className="flex items-center gap-4 mb-8">
                                    <span className="text-5xl font-black text-gray-300 group-hover:text-white/20 transition-colors">02</span>
                                    <h3 className="text-3xl font-bold text-[#021d53] group-hover:text-white">Upper Elementary</h3>
                                </div>
                                <p className="text-[#021d53] group-hover:text-white font-bold mb-6">Year 4 – Year 7</p>
                                <p className="text-gray-600 group-hover:text-red-50 text-lg mb-10 leading-relaxed">
                                    Preparing students for higher academic demands and greater independence. Learners are guided to think more critically, communicate effectively, and take ownership of their learning.
                                </p>

                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                    {upperCurriculum.map((item, idx) => (
                                        <div key={idx} className="flex items-start gap-3">
                                            <div className="text-2xl text-[#021d53] group-hover:text-white mt-1 shrink-0">{item.icon}</div>
                                            <div className="text-sm font-semibold text-gray-700 group-hover:text-white">{item.title}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Character & Approach - Interlocking Cards */}
                    <section className="py-20 bg-white">
                        <div className="max-w-[1440px] mx-auto grid xl:grid-cols-3 gap-8">
                            <div className="xl:col-span-2 space-y-8">
                                <h2 className="text-4xl font-bold text-[#021d53]">Academic & Character Goals</h2>
                                <div className="grid md:grid-cols-2 gap-8">
                                    <div className="p-10 bg-[#f0f4ff] rounded-3xl border-b-8 border-[#021d53]">
                                        <MdEmojiPeople className="text-4xl text-[#021d53] mb-4" />
                                        <h4 className="text-xl font-bold mb-4">Integrity & Leadership</h4>
                                        <p className="text-gray-600 leading-relaxed text-sm">
                                            We intentionally shape learners to be disciplined, respectful, responsible, and confident. Emphasis is placed on teamwork, empathy, leadership skills, and accountability.
                                        </p>
                                    </div>
                                    <div className="p-10 bg-[#fff0f0] rounded-3xl border-b-8 border-[#ed3137]">
                                        <FaUser className="text-3xl text-[#ed3137] mb-4" /> {/* FaUser might not be imported, using placeholder or finding better icon */}
                                        <MdAutoGraph className="text-4xl text-[#ed3137] mb-4" />
                                        <h4 className="text-xl font-bold mb-4">Growth Mindset</h4>
                                        <p className="text-gray-600 leading-relaxed text-sm">
                                            Students are encouraged to set goals, manage responsibilities, and contribute positively to their school community, cultivating resilience and a drive for excellence.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-[#221b2d] text-white p-12 rounded-[3rem] flex flex-col justify-center">
                                <h3 className="text-2xl font-bold mb-6">Our Approach</h3>
                                <p className="text-gray-300 leading-relaxed italic border-l-4 border-[#ed3137] pl-6">
                                    "Balancing direct teaching with inquiry-based and collaborative learning. Research tasks, presentations, and group projects ensure learners connecting learning with the world."
                                </p>
                            </div>
                        </div>
                    </section>
                </div>
                <div className="col-span-12 lg:col-span-4 mb-3">
                    <h2 className=' pb-5 text-2xl font-bold text-[#021d53] mb-4'>ELEMENTARY EVENTS</h2>
                    {loadingEvents ? (
                        <div className="flex items-center justify-center p-10 h-[180px]">
                            <RotatingLines
                                strokeColor="#021D53"
                                strokeWidth="5"
                                animationDuration="0.75"
                                width="40"
                                visible={true}
                            />
                        </div>
                    ) : (
                        <>
                            {elementaryEvents?.length > 0 ? (
                                elementaryEvents.map((event) => (
                                    <div key={event.id} className='flex gap-4 my-[15px] min-h-[140px] bg-gray-50'>
                                        <div className='flex flex-col items-center justify-center w-[30%] bg-[#021d53] text-white shrink-0'>
                                            <span className="text-3xl font-bold mb-1">{event.day}</span>
                                            <span className="text-xs uppercase">{event.month?.substring(0, 3)}</span>
                                        </div>
                                        <div className='py-6 px-4 flex flex-col justify-center text-sm'>
                                            <h4 className="text-xl font-bold mb-1 leading-tight">{event.title}</h4>
                                            <span className='text-gray-500 font-medium'>{event.time}</span>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className='flex items-center justify-center h-[180px] bg-gray-50 text-gray-500 italic'>
                                    No upcoming events
                                </div>
                            )}
                        </>
                    )}
                    <div className="flex items-center justify-center mt-8">
                        <Link to="/news-events/calendar" className="w-full">
                            <button className="w-full bg-transparent border border-[#021d53] text-[#021d53] px-12 py-3 font-bold text-lg hover:bg-[#021d53] hover:text-white transition-all uppercase tracking-widest shadow-lg hover:scale-105 active:scale-95 text-center">VIEW CALENDAR</button>
                        </Link>
                    </div>
                </div>
            </div>

            {/* Transition Section */}
            <section className="py-20 bg-[#021d53] text-white relative overflow-hidden">
                <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] animate-pulse"></div>
                <div className="max-w-4xl mx-auto text-center px-5">
                    <h2 className="text-3xl md:text-4xl font-bold mb-8">Preparation for the Future</h2>
                    <p className="text-lg text-blue-100 leading-relaxed">
                        Our Elementary School ensures a smooth transition into secondary education. By Year 7, students are academically equipped, emotionally mature, and intellectually prepared for advanced study. We guide our learners to think independently, act responsibly, and pursue excellence with confidence.
                    </p>
                </div>
            </section>

            {/* Elementary Activity Photo Collage */}
            <section className="py-20 px-5 md:px-20 lg:px-40 bg-white">
                <div className="max-w-6xl mx-auto">
                    {/* Section Header */}
                    <div className="text-center mb-12">
                        <div className="flex items-center justify-center gap-4 mb-4">
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                            <p className="text-[#ed3137] font-bold uppercase tracking-widest text-sm">Life at Elementary</p>
                            <div className="h-1 w-12 bg-[#ed3137] rounded-full"></div>
                        </div>
                        <h2 className="text-3xl md:text-4xl font-extrabold text-[#021d53]">A Glimpse Into Our World</h2>
                        <p className="text-gray-500 mt-3 max-w-xl mx-auto text-sm">Learning, growing, and thriving — every day at Anell Elementary is an adventure worth capturing.</p>
                    </div>

                    {/* CSS Columns masonry — auto-balances any number of photos */}
                    <div className="columns-2 md:columns-3 lg:columns-4 gap-3">
                        {[
                            EActImg1,  EActImg2,  EActImg3,  EActImg4,  EActImg5,
                            EActImg6,  EActImg7,  EActImg8,  EActImg9,  EActImg10,
                            EActImg11, EActImg12, EActImg13, EActImg14
                        ].map((src, i) => (
                            <div
                                key={i}
                                className="break-inside-avoid mb-3 overflow-hidden rounded-xl group cursor-pointer"
                            >
                                <img
                                    src={src}
                                    alt={`Elementary activity ${i + 1}`}
                                    className="w-full object-cover rounded-xl transition-transform duration-500 group-hover:scale-105"
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
            
        </div>
    );
};

export default ElementarySchool;
